<div>
  <form class="form" [formGroup]="form">
    <div class="form-body">
      <h4 class="form-section">
        <i class="ft-list"></i> {{ title }}
      </h4>

      <div *ngIf="formModules.controls.length > 0; else noModulesTemplate">
        <!-- Modules -->
        <div formArrayName="formModules" *ngFor="let formModule of formModules.controls; index as i;">
          <div class="row ml-0" [formGroupName]="i">

            <div *ngIf="formModule.value.IsActive" class="form-group col-md-1">
              <i class="circle bg-green"></i>
            </div>
            <div *ngIf="!formModule.value.IsActive" class="form-group col-md-1">
              <i class="circle bg-red"></i>
            </div>

            <!-- IsChecked -->
            <div class="custom-control custom-checkbox col-md-4">
              <input type="checkbox" class="custom-control-input" formControlName="IsChecked">
              <label class="custom-control-label">{{ formModule.value.Name }}</label>
            </div>

            <!-- TransactionFee -->
            <div *ngIf="displayTransactionFee" class="form-group col-md-3">
              <label>{{ transactionFeeFieldLabel }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">€</span>
                </div>
                <input type="number" min="0" class="form-control company-input" formControlName="TransactionFee"
                       placeholder="Transaction Fee">
              </div>
            </div>

            <!-- RefundCost -->
            <div *ngIf="displayTransactionFee" class="form-group col-md-3">
              <label>{{ refundCostFieldLabel }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">€</span>
                </div>
                <input type="number" min="0" class="form-control company-input" formControlName="RefundCost"
                       placeholder="Refund Cost">
              </div>
            </div>

          </div>
        </div>
      </div>
      <ng-template #noModulesTemplate>
        {{ noModulesAvailableMessage }}
      </ng-template>
    </div>
  </form>
</div>
